// Helpers for the native <input type="datetime-local"> control, which works entirely in the
// browser's LOCAL time. Building its `min` with `new Date().toISOString()` is wrong: toISOString()
// returns UTC, so in a non-UTC zone (e.g. Somalia, UTC+3) the min lands hours away from local wall
// clock and the picker lets you choose times that are actually in the past. Shift by the timezone
// offset first so the "YYYY-MM-DDTHH:mm" string reads as local time.
export function datetimeLocalMin(leadMs = 60_000): string {
  const d = new Date(Date.now() + leadMs);
  d.setMinutes(d.getMinutes() - d.getTimezoneOffset());
  return d.toISOString().slice(0, 16);
}
